import { InjectionToken } from '@angular/core';

import { AngleDown, AngleLeft, AngleRight, AngleUp, ArrowDown, ArrowFilledDown, ArrowFilledLeft, ArrowFilledRight, ArrowFilledUp, ArrowLeft, ArrowLeftSmall, ArrowRight, ArrowRightSmall, ArrowUp } from './icons/arrow';
import { CloseCircle } from './icons/close';
import { BadgeCheck, Check, CheckCircleFilled } from './icons/check';
import { Phone, PhoneOutline, TelephoneOutline } from './icons/phone';
import { Menu } from './icons/menu';
import { HardwareDiagnostics, MalwareRemoval, NetworkAdministration, RemoteSupport, Security, WorkFromHome } from './icons/color-icons';
import { Facebook, Instagram, Linkedin } from './icons/social';
import { BoltCircle, CalendarColored, ComputerSetup, Copy, CyberInsurance, DataBase, DataProtection, DataRecovery, Downtime, FolderConnect, GamingRemote, HelpDesk, Laptop, Layer, MSP, Maintenance, MoneyControl, NetworkAdmin, OutlinedShieldSecure, Patch, Printer, SocialMediaSecurity, TransferStorage, UpArrowCircle, VideoSecurity, WirelessSignals } from './icons/services';
import { EnvelopOutline } from './icons/envelop';

export const Icons = new Map([
  ['angle-left', AngleLeft],
  ['angle-right', AngleRight],
  ['angle-up', AngleUp],
  ['angle-down', AngleDown],
  ['arrow-left', ArrowLeft],
  ['arrow-right', ArrowRight],
  ['arrow-up', ArrowUp],
  ['arrow-down', ArrowDown],
  ['arrow-filled-left', ArrowFilledLeft],
  ['arrow-filled-right', ArrowFilledRight],
  ['arrow-filled-up', ArrowFilledUp],
  ['arrow-filled-down', ArrowFilledDown],
  ['arrow-left-sm', ArrowLeftSmall],
  ['arrow-right-sm', ArrowRightSmall],
  ['badge-check', BadgeCheck],
  ['close-circle', CloseCircle],
  ['check', Check],
  ['check-circle-filled', CheckCircleFilled],
  ['envelop-outline', EnvelopOutline],
  ['phone', Phone],
  ['phone-outline', PhoneOutline],
  ['telephone-outline', TelephoneOutline],
  ['menu', Menu],

  ['remote-support', RemoteSupport],
  ['work-from-home', WorkFromHome],
  ['network-administration', NetworkAdministration],
  ['malware-removal', MalwareRemoval],
  ['hardware-diagnostics', HardwareDiagnostics],
  ['security', Security],

  ['linkedin', Linkedin],
  ['facebook', Facebook],
  ['instagram', Instagram],

  ['bolt-circle', BoltCircle],
  ['outlined-shield-secure', OutlinedShieldSecure],
  ['up-arrow-circle', UpArrowCircle],
  ['gaming-remote', GamingRemote],
  ['database', DataBase],
  ['social-media-security', SocialMediaSecurity],
  ['laptop', Laptop],
  ['wireless-signals', WirelessSignals],
  ['printer', Printer],
  ['computer-setup', ComputerSetup],
  ['video-security', VideoSecurity],
  ['network-admin', NetworkAdmin],
  ['msp', MSP],
  ['cyber-insurance', CyberInsurance],
  ['data-protection', DataProtection],
  ['downtime', Downtime],
  ['patch', Patch],
  ['calendar-colored', CalendarColored],
  ['layer', Layer],
  ['maintenance', Maintenance],
  ['help-desk', HelpDesk],
  ['folder-connect', FolderConnect],
  ['copy', Copy],
  ['money-control', MoneyControl],
  ['transfer-storage', TransferStorage],
  ['data-recovery', DataRecovery]
]);

export const ICONS = new InjectionToken('ICONS');
